import { type PayloadAction, createSlice } from "@reduxjs/toolkit"
import { IMatchSessionResponse } from "@/store/apis/matchAPI"
import { IMatchSliceState } from "."

export const initialState: IMatchSliceState = {
  matchSession: undefined,
  isSocketConnect: false
}

export const MatchSlice = createSlice({
  name: "match",
  initialState,
  reducers: {
    setMatchSession: (
      state,
      { payload }: PayloadAction<IMatchSessionResponse>
    ) => {
      state.matchSession = payload
    },
    clearMatchState: (state) => {
      state.matchSession = undefined
    },
    setSocketConnected: (state, { payload }: PayloadAction<boolean>) => {
      state.isSocketConnect = payload
    }
  }
})

export const { setMatchSession, clearMatchState, setSocketConnected } =
  MatchSlice.actions
